import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import PropertygroupsCreateForm from './PropertygroupsCreateForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { createPropertygroup } from 'store/actions/propertygroups/createPropertygroups';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';

class PropertygroupsCreateContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/propertygroups/${ id }/show`));
                },
                formValues: convertedValues,
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.propertygroups.plural'),
                link: '/propertygroups',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.propertygroups.actions.create') } />

                    <Actions>
                        <ListButton url='/propertygroups' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PropertygroupsCreateForm
                            form='propety_groups_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PropertygroupsCreateContainer.contextTypes = {
    config: PropTypes.object,
};

PropertygroupsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createPropertygroup(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(PropertygroupsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/create/PropertygroupsCreateContainer.js